export default "__VITE_ASSET__0lHPCNzv__"